// 两种环境变量：
// vite变量，构建时引入
// 丹炉环境变量（构建在基础镜像里），部署时引入
// 前端项目丹炉环境变量https://confluence.leihuo.netease.com/pages/viewpage.action?pageId=178686109
import Cookies from 'js-cookie';

export const getEnv = () => {
  const viteEnv = import.meta.env;
  const mode = import.meta.env.MODE;
  const isInternal = viteEnv?.VITE_LOCAL_INTERNAL ? true : (window as any)?.EEVEE_FOR_INTERNAL;
  const fosHost = (window as any)?.EEVEE_FOS_HOST || viteEnv?.VITE_FOS_HOST;
  let danqingLink = viteEnv?.VITE_DANQING_LINK;
  let yushengLink = viteEnv?.VITE_YUSHENG_LINK;
  if (window.location.href.indexOf('163.com') === -1) {
    const params = `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}&RBAC_USER=${Cookies.get('RBAC_USER')}`;
    if (danqingLink?.indexOf('163.com') > -1) {
      danqingLink += (danqingLink.indexOf('?') > -1 ? '&' : '?') + params;
    }
    if (yushengLink?.indexOf('163.com') > -1) {
      yushengLink += (danqingLink.indexOf('?') > -1 ? '&' : '?') + params;
    }
  }
  const wsServer = (window as any)?.EEVEE_WS_URL;
  const uploadAssetTemplateId = (window as any).EEVEE_UPLOAD_ASSET_TEMPLATE_ID;
  return { ...viteEnv, isInternal, mode, fosHost, danqingLink, yushengLink, wsServer, uploadAssetTemplateId };
};
